import React, { useMemo } from "react";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import "../styles/TablePagination.css";
const TablePagination = ({
  pagination, // { page, pageSize, total, totalPages }
  onPageSizeChange, // Function(newSize)
  loading = false,
  onPageChange,
  pageSizeOptions = [2, 5, 10, 20, 50, 100, 200, 300],
}) => {

  // Logic to generate page numbers
const pageNumbers = useMemo(() => {
  if (!pagination) return [];
  return Array.from(
    { length: pagination.totalPages },
    (_, i) => i + 1
  );
}, [pagination]);


  if (!pagination) return null;

  return (
    <div className="datagrid-footer">
      {/* Left Side: Items per page + Range Text */}
      <div className="datagrid-footer-left-items">
        <div className="d-flex align-items-center">
          <select
            className="footer-select"
            value={pagination.pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            disabled={loading}
          >
            {pageSizeOptions.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          <span>Items per page</span>
        </div>

        <div style={{ color: "#6c757d" }}>
          {pagination.total > 0 ? pagination.page * pagination.pageSize + 1 : 0}
          {" - "}
          {Math.min(
            (pagination.page + 1) * pagination.pageSize,
            pagination.total
          )}{" "}
          of {pagination.total} items
        </div>
      </div>

      {/* Right Side: Page Jumper + Controls */}
      <div className="d-flex align-items-center gap-2">
        <div className="page-tracker">
          <select
            className="page-select-dropdown"
            value={pagination.page + 1}
            onChange={(e) => onPageChange(Number(e.target.value) - 1)}
            disabled={loading}
          >
            {pageNumbers.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>

          <span style={{ color: "#adb5bd" }}>
            of {pagination.totalPages} pages
          </span>
        </div>

        <button
          className="pagination-btn"
          onClick={() => onPageChange(pagination.page - 1)}
          disabled={pagination.page === 0 || loading}
        >
          <AiOutlineLeft size={14} />
        </button>
        <button
          className="pagination-btn"
          onClick={() => onPageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages-1 || loading}
        >
          <AiOutlineRight size={14} />
        </button>
      </div>
    </div>
  );
};

export default TablePagination;
